import React from "react";

export const ShowcaseComingSoon = () => {
  return (
    <div className={"ShowcaseComingSoon"}>
      <div className={"ShowcaseComingSoon__Content"}>Coming soon!</div>
    </div>
  )
}